import { render, staticRenderFns } from "./BrandHistory.vue?vue&type=template&id=56f77d00&scoped=true"
import script from "./BrandHistory.vue?vue&type=script&lang=js"
export * from "./BrandHistory.vue?vue&type=script&lang=js"
import style0 from "./BrandHistory.vue?vue&type=style&index=0&id=56f77d00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f77d00",
  null
  
)

export default component.exports